<div class="modal">
  <div class="card">
    <div class="card-header">
      <div class="card-title">Rokovi za sukcesivnu isporuku</div>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-12">
          <table class="table table-hover table-outline table-vcenter card-table table-sticky">
            <thead>
              <tr>
                <th class="width-30">Rok</th>
                <th class="width-20">Količina</th>
                <th class="width-50">Komentar</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let deadline of order?.partialDeliveryInfo; let i = index">
                <td class="fw-bold">{{ deadline.date | date: 'dd/MM/yyyy' }}</td>
                <td>{{ deadline.quantity }}</td>
                <td>{{ deadline.comment || '/' }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="card-footer text-end">
      <button class="btn btn-secondary btn-question" (click)="emitFalse()">Nazad</button>
    </div>
  </div>
</div>
